module.exports = __webpack_public_path__ + "static/media/testen-er-ferdig.b88fd722.wav";